import {ChangeDetectionStrategy, Component, Inject, Injectable} from "@angular/core";
import {BeslutningId, BeslutningModell, OppdaterBeslutningOgOppgaverSpesifikasjon} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {BeslutningDatatjeneste} from "felles-ng2/tjenester/datalager/BeslutningDatatjeneste";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {asynkArbeidPågårSignal, standardMinimumVarighetKonfig} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {BeslutningSkjemaKomponent} from "../../komponenter/beslutning-skjema/beslutning-skjema";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatToolbar} from "@angular/material/toolbar";
import {ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";

const debug = initDebugger('BeslutningRedigerDialogKomponent');


/**
 * Dialog for å redigere beslutning
 */
@Component({
    selector: 'beslutning-rediger-dialog',
    templateUrl: 'beslutning-rediger-dialog.html',
    styleUrl: 'beslutning-rediger-dialog.scss',
    host: {'data-testid': 'beslutning-skjema-dialog'},
    imports: [
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatIcon,
        MatIconButton,
        MatToolbar,
        BeslutningSkjemaKomponent,
        ReactiveFormsModule,
        TranslateModule,
        VisSpinnerDirektiv,
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BeslutningRedigerDialogKomponent {
    static vis(dialog: MatDialog, beslutning: BeslutningModell): MatDialogRef<BeslutningRedigerDialogKomponent, BeslutningRedigerDialogRespons> {
        return dialog.open(BeslutningRedigerDialogKomponent, {
            data: {beslutning} as DialogParametre,
            disableClose: true,
            ariaLabelledBy: 'beslutning-rediger-dialog-tittel',
            minWidth: 500
        });
    }

    beslutning: BeslutningModell; //kommer fra DialogParametre

    skjema = BeslutningSkjemaKomponent.opprettSkjema();

    lagrer = asynkArbeidPågårSignal(standardMinimumVarighetKonfig());

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                private dialogRef: MatDialogRef<BeslutningRedigerDialogKomponent, BeslutningRedigerDialogRespons>,
                private avhengigheter: BeslutningRedigerDialogKomponentAvhengigheter) {
        this.beslutning = parametre.beslutning;

        BeslutningSkjemaKomponent.populerSkjema(this.skjema, this.beslutning);
    }

    async lagre() {
        await this.lagrer.utfør(() => this.avhengigheter.oppdater(this.beslutning.id, this.somSpesifikasjon()));
        this.dialogRef.close(true);
    }

    avbryt() {
        this.dialogRef.close(false);
    }

    // private hjelpemetoder

    private somSpesifikasjon(): OppdaterBeslutningOgOppgaverSpesifikasjon {
        return {
            ...BeslutningSkjemaKomponent.somSpesifikasjon(this.skjema),
            sakId: this.beslutning.sakId,
            erForslag: this.beslutning.erForslag
        };
    }
}

export type BeslutningRedigerDialogRespons = boolean;

export type DialogParametre = {
    beslutning: BeslutningModell;
};

@Injectable()
export class BeslutningRedigerDialogKomponentAvhengigheter {

    constructor(private beslutningDatatjeneste: BeslutningDatatjeneste) {
    }

    async oppdater(id: BeslutningId, spesifikasjon: OppdaterBeslutningOgOppgaverSpesifikasjon): Promise<void> {
        await this.beslutningDatatjeneste.oppdater(id, spesifikasjon);
    }
}
